/** Generated by scripts/write-build-info.mjs — do not edit by hand. */
export const BUILD_INFO = {
  version: "1.5.2",
  commitSha: "55e3174",
  branch: "dev",
  builtAt: "2026-11-04T08:30:24.752Z",
} as const;
